import React, { useState, useEffect, useCallback } from 'react';
import api from '../lib/api';
import { Input } from './ui/input';
import { RefreshCw, ShieldCheck } from 'lucide-react';

export default function CaptchaWidget({ onVerified, resetTrigger }) {
  const [captchaId, setCaptchaId] = useState('');
  const [image, setImage] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  const loadCaptcha = useCallback(async () => {
    setLoading(true);
    setAnswer('');
    onVerified(null, null);
    try {
      const r = await api.get('/captcha');
      setCaptchaId(r.data.captcha_id);
      setImage(r.data.image);
    } catch { /* ignore */ }
    finally { setLoading(false); }
  }, [onVerified]);

  useEffect(() => { loadCaptcha(); }, [loadCaptcha, resetTrigger]);

  useEffect(() => {
    if (answer && captchaId) {
      const parsed = parseInt(answer);
      if (!isNaN(parsed)) {
        onVerified(captchaId, parsed);
      }
    }
  }, [answer, captchaId, onVerified]);

  return (
    <div className="space-y-2" data-testid="captcha-widget">
      <label className="text-sm font-medium text-slate-700 flex items-center gap-1.5">
        <ShieldCheck className="w-4 h-4 text-slate-400" />
        Guvenlik Dogrulamasi
      </label>
      <div className="flex items-center gap-3">
        <div className="relative rounded-lg overflow-hidden border border-slate-200 bg-white shadow-sm">
          {loading ? (
            <div className="w-[200px] h-[70px] flex items-center justify-center">
              <RefreshCw className="w-5 h-5 animate-spin text-slate-400" />
            </div>
          ) : (
            <img
              src={`data:image/png;base64,${image}`}
              alt="CAPTCHA"
              className="w-[200px] h-[70px] select-none"
              draggable={false}
              data-testid="captcha-image"
            />
          )}
        </div>
        <button
          type="button"
          onClick={loadCaptcha}
          className="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors"
          title="Yeni kod"
          data-testid="captcha-refresh"
        >
          <RefreshCw className="w-4 h-4 text-slate-500" />
        </button>
      </div>
      <Input
        type="number"
        placeholder="Sonucu yazin"
        value={answer}
        onChange={e => setAnswer(e.target.value)}
        className="w-[200px]"
        data-testid="captcha-input"
      />
    </div>
  );
}
